import type { GovernedTask } from "owa-tti/lib/types/GovernedTask";

export type IframeScenario = "BizChatSidebar" | "HelpPane" | "RewardsPane";

export type ScenarioSettings<TScenario extends IframeScenario = IframeScenario> = {
    matchUrl: (url: string) => boolean;
    enableCaching: boolean;
} & ({
    enablePreloading: false;
    governTask?: never;
} | {
    enablePreloading: true;
    governTask: Pick<GovernedTask, "name" | "ownership"> & {
        name: `iframe-preload-${TScenario}`;
    };
});

const defaultSettings = {
    enablePreloading: false,
    enableCaching: false,
} as const;

export const iframesMapping: {
    [Scenario in IframeScenario]: ScenarioSettings<Scenario>;
} = {
    BizChatSidebar: {
        ...defaultSettings,
        matchUrl: (url: string) => url.includes("/hosted/semanticoverview/") || url.includes("m365copilotapp"),
        enablePreloading: true,
        governTask: {
            name: "iframe-preload-BizChatSidebar",
            ownership: ["monarchmailchatcopilotfc@service.microsoft.com"],
        },
        enableCaching: true,
    },
    HelpPane: {
        ...defaultSettings,
        matchUrl: (url: string) => url.includes("https://cjs.diagnostics.office.com/support"),
    },
    RewardsPane: {
        ...defaultSettings,
        matchUrl: (url: string) => url.includes("rewards/panelflyout"),
        // Temporary OWA-only workaround: keep the Rewards flyout iframe mounted-but-hidden
        // so repeated opens are instant. Gated (in useIframeSettings) behind the existing
        // Rewards feature flight and protected by a safe-window guard in RewardsPane that
        // forces a reload whenever Bing's ANID re-check must run. Preloading stays off
        // (privacy).
        enableCaching: true,
    },
};
